module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Clipboard-b20c185070139f071b36c7731149c51a.svg";